import { matchesMeetingTemplate } from '@confluence/experiment-meeting-signal-core/entry-points/matchesMeetingTemplate.ts';
import { matchMeetingSignal } from '@confluence/experiment-meeting-signal-core/entry-points/matchMeetingSignal.ts';

import {
	MEETING_NOTES_CONTENT_KEYWORDS,
	MEETING_NOTES_TITLE_KEYWORDS,
} from './meetingNotesKeywords.ts';

const MINIMUM_CONTENT_WORD_COUNT = 50;

const countWords = (text?: string | null): number => {
	const trimmedText = text?.trim();
	return trimmedText ? trimmedText.split(/\s+/).length : 0;
};

export type MeetingNotesSignalInput = {
	title?: string | null;
	content: string;
	sourceTemplateEntityId: string;
};

export type MeetingNotesMatch = {
	matches: boolean;
	matchedTitle: boolean;
	matchedContent: boolean;
	matchedTemplate: boolean;
};

/**
 * Pure, synchronous meeting-notes signal match against a page's title, body text
 * and source template.
 */
export const matchesMeetingNotesSignal = ({
	title,
	content,
	sourceTemplateEntityId,
}: MeetingNotesSignalInput): MeetingNotesMatch => {
	const matchedTitle = !!title && matchMeetingSignal(title, MEETING_NOTES_TITLE_KEYWORDS);
	const matchedContent =
		countWords(content) >= MINIMUM_CONTENT_WORD_COUNT &&
		matchMeetingSignal(content, MEETING_NOTES_CONTENT_KEYWORDS);
	const matchedTemplate =
		!!sourceTemplateEntityId &&
		matchesMeetingTemplate({ idType: 'other', id: sourceTemplateEntityId });

	return {
		matches: matchedTitle || matchedContent || matchedTemplate,
		matchedTitle,
		matchedContent,
		matchedTemplate,
	};
};
